import React, { useState } from 'react'
import { SearchableSelectBase } from 'components'
import { useDTGProductsOptions } from '../../hooks'

type Props = {
  initialOption: SelectOption
  disabled?: boolean
  onSelect: (selectOption: SelectOption) => void
}

const DTGProductsSelect = (props: Props) => {
  const [searchText, setSearchText] = useState<string>('')
  const { data, isLoading } = useDTGProductsOptions(searchText)

  return (
    <SearchableSelectBase
      {...props}
      options={data?.map((item) => ({ id: item.id, name: item.name }))}
      onSearch={(newSearchText: string) => setSearchText(newSearchText)}
      isLoading={isLoading}
    />
  )
}

export default DTGProductsSelect
